import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useApp } from '@/context/AppContext';
import { ChevronRight, ChevronDown, ChevronUp } from 'lucide-react';

export default function FelicitacionesStep() {
  const navigate = useNavigate();
  const { state } = useApp();
  const [showExplanation, setShowExplanation] = useState(false);

  // Handle header back button clicks
  useEffect(() => {
    const handleHeaderBack = () => {
      // Navigate back to the mask sizing result screen
      navigate('/eleccion/medicion-resultado');
    };

    window.addEventListener('headerBackClick', handleHeaderBack);
    return () => window.removeEventListener('headerBackClick', handleHeaderBack);
  }, [navigate]);

  const { 
    maskRecommendation, 
    breathingSelfReport, 
    noseScore, 
    maskSizing
  } = state.eleccion;

  const continuarAProductos = () => {
    navigate('/eleccion/productos');
  };

  const ajustarRespuestas = () => {
    navigate('/eleccion/respiracion');
  };

  const getLogicHint = () => {
    if (breathingSelfReport === 'bien') return '';
    return noseScore >= 50 ? 'moderada/alta' : 'baja';
  };

  const getMaskType = () => {
    if (breathingSelfReport === 'bien') return 'Nasal';
    return maskRecommendation || 'Nasal';
  };

  return (
    <div className="flex flex-col min-h-[calc(100vh-80px)] overflow-x-hidden">
      <div className="flex-1 container px-4 py-6 sm:py-8 pb-24 max-w-none">
        <div className="max-w-4xl mx-auto overflow-hidden">
          <h1 className="text-2xl font-bold text-primary mb-4 text-center">
            Encontramos tu mascarilla ideal
          </h1>
          <Card className="mb-6 pt-6">
            <CardContent className="space-y-6">
              {/* Subtítulo corto */}
              <div className="text-center">
                <p className="text-lg font-semibold text-foreground">
                  {getMaskType()} • Talla {{'S': 'Pequeña', 'M': 'Mediana', 'L': 'Grande'}[maskSizing?.maskSize].toLowerCase() || 'M'}
                </p>
              </div>

              <div className="border border-gray-200 rounded-md">
                <button
                  onClick={() => setShowExplanation(!showExplanation)}
                  className="w-full p-3 flex items-center justify-between text-left hover:bg-gray-50 rounded-md"
                >
                  <span className="text-sm font-medium text-primary">
                    ¿Por qué esta opción?
                  </span>
                  {showExplanation ? (
                    <ChevronUp className="h-4 w-4 text-primary" />
                  ) : (
                    <ChevronDown className="h-4 w-4 text-primary" />
                  )}
                </button>
                
                {showExplanation && (
                  <div className="p-3 pt-0 border-t border-gray-200">
                    <ul className="space-y-2 text-sm text-foreground">
                      <li className="mt-4">• {breathingSelfReport === 'bien' 
                        ? 'Respiras bien por la nariz y prioriza comodidad.'
                        : `Detectamos ${getLogicHint()} obstrucción nasal y este tipo de mascarilla prioriza tu comodidad.`}
                      </li>
                      <li className="mt-4">• Facilita la adaptación y el descanso desde la primera noche.</li>
                    </ul>
                  </div>
                )}
              </div>
            </CardContent>
          </Card>

          <h1 className="text-2xl font-bold text-primary mb-4 text-center">
            Siguiente paso:<br/>Seleccionar tu kit (CPAP + mascarilla)
          </h1>

          {/* Botones de acción */}
          <div className="space-y-3">
            {/* CTA principal */}
            <Button 
              className="w-full min-h-touch text-lg px-6 sm:px-8 gap-0" 
              onClick={continuarAProductos}
            >
              <span className="">Ir a crear mi kit</span>
              <ChevronRight style={{ marginLeft: '2.5px', width: '1.25rem', height: '1.25rem', strokeWidth: '3px'}}/>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}